<template>
    <section>

      <!-- <div style="height: 10px;">&nbsp;</div> -->

      <div class="img">
        <div style="width: 100%;">
          <img src="../assets/gaoxiaoUse.jpg" style="width: 100%;height: 100%;" />
        </div>
      </div>



      <div style="text-align: center;margin: -840px 0 0;" v-if="this.phoneType=='android'">
        <div style="margin: 0 auto 20px;width: 90%">
          <div style="margin: 15px 0 20px;">
            <span style="width: 110px;margin-right: 5px;font-weight: bold;color: black;">
              <img src="../assets/school.png"  style="width: 15px;height: 20px;margin-top: -5px;" />&nbsp;&nbsp;学校名称&nbsp;&nbsp;
            </span>
            <input
              style="width: 172px;background: #f3f3f3;padding: 4px 10px;border-radius: 30px;border: none;"
              readonly="true"
              @click="selectEndAddress()"
              placeholder="请选择您的学校名称"
              placeholder-style="color:red;"
              type="text"
              :value="this.Address"
            />
          </div>

          <div style="margin: 15px 0 20px;">
            <span style="width: 110px;margin-right: 5px;font-weight: bold;color: black;">
              <img src="../assets/name.png"  style="width: 20px;height: 20px;margin-top: -5px;" />&nbsp;&nbsp;您的姓名&nbsp;&nbsp;
            </span>
            <input
              style="width: 172px;background: #f3f3f3;padding: 4px 10px;border-radius: 30px;border: none;"
              placeholder="请填写您的姓名"
              v-model="inputname"
            />
          </div>

          <div style="margin: 15px 0 20px;">
            <span style="width: 110px;margin-right: 5px;font-weight: bold;color: black;">
              <img src="../assets/phone.png"  style="width: 20px;height: 20px;margin-top: -5px;" />&nbsp;&nbsp;电话号码&nbsp;&nbsp;
            </span>
            <input
              style="width: 172px;background: #f3f3f3;padding: 4px 10px;border-radius: 30px;border: none;"
              placeholder="请填写您的电话号码"
              v-model="inputphone"
            />
          </div>

          <div style="margin: 15px 0;">
            <button style="background: #2168ac;border-radius: 30px;font-size: 20px !important;box-shadow: none;width: 85%;height: 45px;line-height: 45px;border: none;color: white;" @click="postOrder">使用优惠</button>
          </div>
        </div>

        <div v-if="this.modal" style="text-align: center;">
        <!-- <div> -->
          <img src="../assets/schoolcoupon.png" style="width: 100%;height: 100%;">
          <div style="width: 93%;padding: 0;margin-bottom: 15px;margin-top: -15px;" @click="showWarningTips">
          	<Icon type="ios-warning" size="24" color="#F39148" />
          	<span style="color: #2168ac;text-decoration: underline;">福利礼包使用规则</span>
          </div>
        </div>

      </div>


      <div style="text-align: center;margin: -945px 0 0;" v-if="this.phoneType=='iPhone'">
        <div style="margin: 0 auto 30px;width: 90%">
          <div style="margin: 15px 0 20px;">
            <span style="width: 110px;margin-right: 5px;font-weight: bold;color: black;">
              <img src="../assets/school.png"  style="width: 15px;height: 20px;margin-top: -5px;" />&nbsp;&nbsp;学校名称&nbsp;&nbsp;
            </span>
            <input
              style="width: 172px;background: #f3f3f3;padding: 4px 10px;border-radius: 30px;border: none;"
              @click="selectEndAddress()"
              readonly="true"
              placeholder="请选择您的学校名称"
              type="text"
              :value="this.Address"
            />
          </div>

          <div style="margin: 15px 0 20px;">
            <span style="width: 110px;margin-right: 5px;font-weight: bold;color: black;">
              <img src="../assets/name.png"  style="width: 20px;height: 20px;margin-top: -5px;" />&nbsp;&nbsp;您的姓名&nbsp;&nbsp;
            </span>
            <input
              style="width: 172px;background: #f3f3f3;padding: 4px 10px;border-radius: 30px;border: none;"
              placeholder="请填写您的姓名"
              v-model="inputname"
            />
          </div>

          <div style="margin: 15px 0 20px;">
            <span style="width: 110px;margin-right: 5px;font-weight: bold;color: black;">
              <img src="../assets/phone.png"  style="width: 20px;height: 20px;margin-top: -5px;" />&nbsp;&nbsp;电话号码&nbsp;&nbsp;
            </span>
            <input
              style="width: 172px;background: #f3f3f3;padding: 4px 10px;border-radius: 30px;border: none;"
              placeholder="请填写您的电话号码"
              v-model="inputphone"
            />
          </div>

          <div style="margin: 15px 0;">
            <button style="background: #2168ac;border-radius: 30px;font-size: 20px !important;box-shadow: none;width: 85%;height: 45px;line-height: 45px;border: none;color: white;" @click="postOrder">使用优惠</button>
          </div>
        </div>

        <div v-if="this.modal" style="text-align: center;">
        <!-- <div style="text-align: center;"> -->
          <img src="../assets/schoolcoupon.png" style="width: 100%;height: 100%;">
          <div style="width: 93%;padding: 0;margin-bottom: 15px;margin-top: -15px;" @click="showWarningTips">
          	<Icon type="ios-warning" size="24" color="#F39148" />
          	<span style="color: #2168ac;text-decoration: underline;">福利礼包使用规则</span>
          </div>
        </div>

      </div>



      <!-- <div style="margin: 15px auto;text-align: center;width: 80%;">
        <button style="background: #356C55;border-radius: 30px;font-size: 20px !important;box-shadow: none;width: 85%;height: 35px;line-height: 35px;border: none;color: white;" @click="addKEFU">客服微信</button>



      </div> -->

      <!-- <Modal
        v-model="modal"
        title="添加客服微信"
        :mask-closable="true"
        :styles="{top: '20px'}"
        :footer-hide="true"
        :scrollable="true">
        <img src="../assets/kefuwechat.jpg">
      </Modal> -->

      <div>
        <div class="show" v-if="this.tips">
          <div style="width: 80%;height:98%;background:white;padding:10px;border-radius: 10px;">
            <div class="close" @click="close">×</div>
            <div style="font-size: 20px;font-weight: bold;color: black;margin-left: 10px;margin-bottom: 10px;">福利礼包使用规则：</div>
            <div style="margin-left: 15px;font-size: 14px;margin-bottom: 10px;">一套礼包内含2张免费高校接送服务，1张广州机场大巴车票换购券，共3张优惠券。</div>
            <div style="margin-left: 15px;font-size: 14px;margin-bottom: 10px;">1、【免费接送车优惠券】1张立即使用，从中山候机楼送您回校；</div>
            <div style="margin-left: 15px;font-size: 14px;margin-bottom: 10px;">2、【免费接送车优惠券】在中山候机楼购买机票后，可赠送1次学校至中山候机楼的接送服务；</div>
            <div style="margin-left: 15px;font-size: 14px;margin-bottom: 10px;">3、【机场大巴换购券】在中山候机楼购买机票后，+29.9元可换购1张从中山候机楼出发到广州机场的大巴车票；</div>
            <div style="margin-left: 15px;font-size: 14px;margin-bottom: 10px;">***上述优惠券每次均可使用一张，不可同时使用，请悉知！如有疑问，可联系客服人员咨询详情，18029902098/18988598006***</div>
            <div style="margin-left: 15px;font-size: 14px;">
              <img src="../assets/kefu.png" style="width: 100%;height: 100%;" >
            </div>
          </div>
        </div>
      </div>

      <!-- <div v-if="this.isAdd" style="border-radius: 16px;text-align: center;border: solid 2px #c1c1c1;width: 80%;margin: 0 auto;"> -->

      <!-- <div style="border-radius: 16px;text-align: center;border: solid 2px #c1c1c1;width: 80%;margin: 0 auto 10px;">
        <div style="margin: 15px 0;">
          <span style="width: 110px;margin-right: 5px;font-weight: bold;color: black;">
            <img src="../assets/cargoplace.png" style="width: 20px;height: 20px;margin-top: -5px;" />
            出发地
          </span>
          <input style="width: 172px;background: #EEEEEE;padding: 4px 10px;border-radius: 30px;border: none;" type="text" value="懿峯亚朵酒店候机楼" readonly="true"/>
        </div>

        <div style="margin: 15px 0;">
          <span style="width: 110px;margin-right: 5px;font-weight: bold;color: black;">
            <img src="../assets/cartoplace.png"  style="width: 20px;height: 20px;margin-top: -5px;" />
            目的地
          </span>
          <input
            style="width: 172px;background: #EEEEEE;padding: 4px 10px;border-radius: 30px;border: none;"
            readonly="true"
            @click="selectEndAddress()"
            placeholder="请选择目的地址"
            placeholder-style="color:red;"
            type="text"
            :value="this.Address"
          />
        </div>

        <div style="margin: 15px 0;">
          <button style="background: #356C55;border-radius: 30px;font-size: 20px !important;box-shadow: none;width: 85%;height: 35px;line-height: 35px;border: none;color: white;" @click="postOrder">优惠支付</button>
        </div>
      </div> -->

      <!-- <div>&nbsp;</div> -->

		</section>


</template>

<script>
  import baseTool from '../utils/baseFunction';
  import orderApi from '@/request/orderApi';
  import paymentApi from '@/request/paymentApi';
  import axios from 'axios';
  export default {
    name: 'UseCoupon1',
    data() {
      return {
        orderData: null,
        totalPrice:20,
        Address:'',
        District:'',
        bookingDate:'',
        modal: false,
        isAdd:false,
        phoneType:'',
        inputname:'',
        inputphone:'',
        tips:false,
      };
    },
    components: {},
    mounted() {
      document.querySelector('body').setAttribute('style', 'background-color:#EAF3FA;overflow-y: scroll;height: auto;min-height: auto;');

      this.getphoneType();
    },
    activated() {},
    methods: {
      showWarningTips(){
        this.tips=true;
      },
      close(){
        this.tips=false;
      },

      getphoneType(){
        //获取userAgent信息
        var userAgentStr = navigator.userAgent;
        var iPhone = new RegExp("iPhone");
        var Android = new RegExp("Android");;
        if(iPhone.test(userAgentStr)){
          this.phoneType = "iPhone";
          console.log('phoneType',this.phoneType);
        }
        else if(Android.test(userAgentStr)){
          this.phoneType = "android";
          console.log('phoneType',this.phoneType);
        }
      },
      addKEFU(){
        // console.log('asddd')
        this.modal=true;
        this.isAdd=true;
      },
      selectEndAddress(){
        var that = this;
        this.$weui.picker([
        {
            label: '电子科技大学中山学院',
            value: 0,
        },
        {
            label: '广东药学院（中山校区）',
            value: 1,
        },
        {
            label: '广东理工职业学院（中山校区）',
            value: 2,
        },
        {
            label: '中山职业技术学院',
            value: 3,
        },
        {
            label: '中山火炬职业技术学院',
            value: 4,
        },
        {
            label: '其他',
            value: 5,
        }
        ], {
           onConfirm: function (result) {
             that.Address = result[0].label;
             that.District = result[0].value;
             // console.log(result[0].label)
             // console.log(result[0].value)
           },
        });
      },

      postOrder() {
        var that = this;
        this.orderData=null;

        var date = new Date()
        var y = date.getFullYear()
        var m = date.getMonth() + 1
        m = m < 10 ? ('0' + m) : m
        var d = date.getDate()
        d = d < 10 ? ('0' + d) : d
        var h = date.getHours()
        h = h < 10 ? ('0' + h) : h
        var s = date.getMinutes()
        s = s < 10 ? ('0' + s) : s

        var bookingDate = y + '-' + m + '-' + d +' '+ h +':'+ s
        this.bookingDate = bookingDate

        console.log(this.$store.state.user.OpenId);
        console.log(this.totalPrice);
        console.log(this.inputname);
        console.log(this.inputphone);
        console.log(this.District);
        console.log(this.Address);
        console.log(this.bookingDate);


        if (this.orderData != null && this.orderData.ID > 0) {
          this.payRequest();
          return;
        }
        if (this.totalPrice <= 0) {
          this.$Message.warning('价格有问题！');
          return;
        }
        if (this.Address == '') {
          this.$Message.warning('请选择您的学校！');
          return;
        }
        if (this.inputname == '') {
          this.$Message.warning('请填写您的姓名！');
          return;
        }
        if (this.inputphone == '') {
          this.$Message.warning('请填写您的电话号码！');
          return;
        }
        if (this.inputphone.length<7 || this.inputphone.length>11){
          this.$Message.warning('您的电话号码格式不正确！');
          return;
        }

        orderApi.CreateBusinessAppointOrderNewHtml(
            this.$store.state.user.OpenId,
            this.inputname,
            "zsairport",
            "懿峯亚朵酒店候机楼",
            1,
            0,
            this.bookingDate,//当前时间
            2,
            this.inputphone,
            this.Address,//"东区街道"
            this.Address,//"中山市东区街道东区中心幼儿园
            // this.bookingStartPointLa,//"22.498563"
            // this.bookingStartPointLo,//"113.402562"
            '',//"22.498563"
            '',//"113.402562"
            "中山市",
            this.totalPrice,//9.9
            '9.9元接送回校',
            0,
            "limit",
            false,
            '',
            ''
          )
          .then(sucRes => {
            if (sucRes.success) {
              this.$Message.success(sucRes.message);
              this.orderData = sucRes.data;
              console.log(this.orderData);
              this.payRequest();
              // this.modal=true;
              // console.log(this.modal)
            } else {
              this.$Message.error(sucRes.message);
            }
          });
      },
      payRequest() {
        var that = this;
        wx.miniProgram.getEnv(function(res) {
          if (res.miniprogram) {
            // true代表在小程序里
            var url = `../webpayprocess/webpayprocess?ordertype=2&id=${that.orderData.ID}&businessid=2`;
            wx.miniProgram.navigateTo({
              url: url
            });
          } else {
            //false代表在公众号里
            paymentApi.getWeChatPayParams(that.$store.state.user.OpenId, that.orderData.ID, 2, 2).then(sucRes => {
              if (sucRes.success) {
                wx.chooseWXPay({
                  timestamp: sucRes.data.timeStamp,
                  nonceStr: sucRes.data.nonceStr,
                  package: sucRes.data.package,
                  signType: sucRes.data.signType,
                  paySign: sucRes.data.paySign,
                  success: res => {
                    that.$Message.success('支付成功！');
                    that.modal=true;
                    console.log(this.modal)
                    // that.$router.replace({
                    //   name: 'MainIndexPage',
                    //   params: {
                    //     page: 'myorder'
                    //   }
                    // });
                  },
                  fail: fail => {
                    that.$Message.warning('支付失败！');
                    that.$router.replace({
                      name: 'MainIndexPage',
                      params: {
                        page: 'myorder'
                      }
                    });
                  }
                });
              } else {
                that.$Message.error(sucRes.message);
              }
            });
          }
        });
      },


    },
  };
</script>

<style>
  .img {
    width: 100%;
    margin:0 auto;
  }
  .show{
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;
  }
  .close{
    text-align: right;
    margin-right: 5px;
    font-size: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/useCoupon1.vue